import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "mx-auto px-4 py-16 sm:px-6 sm:py-24 lg:max-w-5xl lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between space-x-4" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-medium text-gray-900" }, "Events")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "p-16 flex justify-center"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-6 grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-10 lg:grid-cols-3 lg:gap-x-8"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "absolute z-10 m-4 bg-white py-1 px-2 rounded" }
const _hoisted_8 = { class: "text-sm font-semibold" }
const _hoisted_9 = { class: "aspect-h-3 aspect-w-4 bg-gray-200 group-hover:opacity-75" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "relative flex flex-1 flex-col space-y-2 p-4" }
const _hoisted_12 = { class: "absolute bg-white -translate-y-full py-2 px-3 rounded-lg text-center shadow-lg" }
const _hoisted_13 = { class: "text-lg leading-5 font-bold" }
const _hoisted_14 = { class: "text-md leading-5 font-semibold text-blaze-orange-600" }
const _hoisted_15 = { class: "text-md font-semibold text-gray-900" }
const _hoisted_16 = { class: "flex items-center mt-1" }
const _hoisted_17 = { class: "ml-2 text-sm text-gray-500" }
const _hoisted_18 = { class: "flex items-center mt-1" }
const _hoisted_19 = { class: "ml-2 text-sm text-gray-500" }

import LoaderComponent from "@/components/LoaderComponent.vue";
import { useRouter } from "vue-router";
import { Event } from "@/models/event/Event";
import { computed, onBeforeMount } from "vue";
import { useEventStore } from "@/stores/eventStore";
import { MapPinIcon } from "@heroicons/vue/24/outline";
import { CalendarIcon } from "@heroicons/vue/24/outline";
import BuyerHeroComponent from "@/components/BuyerHeroComponent.vue";
import { getDay, getMonth, formatDate } from "@/helpers/date.helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


const eventPlaceholderImage = process.env.VUE_APP_EVENT_PLACEHOLDER_IMAGE;

const router = useRouter();
const eventStore = useEventStore();

onBeforeMount(() => {
  eventStore.fetchAllEvents();
});

const eventDay = computed(() => (dateString: string) => getDay(dateString));
const eventMonth = computed(() => (dateString: string) => getMonth(dateString));
const eventStartDateTime = computed(() => (dateString: string) => formatDate(dateString));

const gotoEventPage = (event: Event) => {
  router.push({
    name: "Event",
    params: {
      eventId: event.id,
    },
  });
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BuyerHeroComponent),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_unref(eventStore).loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(LoaderComponent)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(eventStore).events, (event) => {
              return (_openBlock(), _createElementBlock("div", {
                key: event.id,
                onClick: ($event: any) => (gotoEventPage(event)),
                class: "group relative flex flex-col overflow-hidden rounded-xl border border-gray-200 bg-white"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(event?.category.replaceAll("_", " ")), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    src: (event?.images && event?.images.length > 0 && event?.images[0].downloadURL) ? event?.images[0].downloadURL : _unref(eventPlaceholderImage),
                    alt: event.title,
                    class: "h-full w-full object-cover object-center sm:h-full sm:w-full"
                  }, null, 8, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h2", _hoisted_13, _toDisplayString(eventDay.value(event?.startTime)), 1),
                    _createElementVNode("h3", _hoisted_14, _toDisplayString(eventMonth.value(event?.startTime)), 1)
                  ]),
                  _createElementVNode("h2", _hoisted_15, [
                    _createVNode(_component_router_link, {
                      to: { name: 'Event', params: { eventId: event?.id } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(event.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_unref(MapPinIcon), {
                      class: "h-4 w-4 text-gray-500",
                      "aria-hidden": "true"
                    }),
                    _createElementVNode("p", _hoisted_17, _toDisplayString(event.location), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_unref(CalendarIcon), {
                      class: "h-4 w-4 text-gray-500",
                      "aria-hidden": "true"
                    }),
                    _createElementVNode("p", _hoisted_19, "On " + _toDisplayString(eventStartDateTime.value(event?.startTime)), 1)
                  ])
                ])
              ], 8, _hoisted_6))
            }), 128))
          ]))
    ])
  ]))
}
}

})